module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_Transition_00124.95006c44.png";